import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/base.css';
import { Router } from './Router';
import { log } from './lib/log';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root not found');
}

log.info('app', `booting build=${import.meta.env.MODE}`);

createRoot(container).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
